import { AppContext } from '../Context.tsx';
import { Fragment, useEffect, useContext, useState, useRef } from 'react';
import axios from 'axios';

//plugins
import InfinityEncryptor from '../i-plugins/InfinityEncryptor.tsx';

//controllers
// import WaitScreenInterfaceController from './WaitScreenInterfaceController';

const nonstate = {
    dbScriptFileMap: {
        // "fetchAppBuild": "appControl.php", //NetworkVersionController --deprecated
        // "fetchAppConfig": "appConfigControl.php", //WatchSyncController
        // // "fetchOtpBypassCode": "appControl.php", //OtpScreen ---deprecated
        // "resendEmailVerification": "mailControl.php", //OtpScreen
        // "resendPhoneVerification": "mailControl.php", //OtpScreen

        // "fetchAllCategories": "categoryControl.php",//watchSyncController
        // "fetchAllFlavors": "flavorControl.php",//watchSyncController
        // "fetchAllTastes": "tasteControl.php",//watchSyncController
        // "fetchAllTextures": "textureControl.php",//watchSyncController
        // "fetchAllUnits": "unitControl.php",//watchSyncController

        // "fetchUserByUsernameAndPassword": "userControl.php", //Login
        // "checkEmailExist": "userControl.php", //Login
        // "checkPhoneExist": "userControl.php", //Login
        // "sendEmailVerification": "mailControl.php", //Login
        // "sendPhoneVerification": "mailControl.php", //Login
        // "createEditNormalUser": "userControl.php", //Login
        // "resetPasswordByUsername": "userControl.php", //Login
        "fetchFooterSignature": "appControl.php", //admin/event_blast
        "updateFooterSignature": "appControl.php", //admin/event_blast, //components/Table/EventBlastTable

        "fetchBlastDrafts": "eblastControl.php", //admin/blast_draft
        "deleteDraft": "eblastControl.php", //admin/blast_draft

        "verifyHCaptcha": "appControl.php", //MembershipRegistration/corporate_register, MembershipRegistration/individual_register

        "updatePaymentRemarks": "paymentControl.php", //CorporateInfo, IndividualInfo
    },
    screenWaitTaskID: 'DATABASEREQUESTCONTROLLER_WAIT_SCREEN'
}

interface Props {
    databaseActionModeQueueRef: any, databaseActionModeQueue: string[], SetDatabaseActionModeQueue: any,
    databaseActionParamsQueueRef: any, databaseActionParamsQueue: any[], SetDatabaseActionParamsQueue: any,
    databaseResultAction: any, SetDatabaseResultAction: any,
    databaseShouldShowWaitScreen: boolean
}

const DatabaseRequestController: React.FC<Props> = ({
        databaseActionModeQueueRef, databaseActionModeQueue, SetDatabaseActionModeQueue,
        databaseActionParamsQueueRef, databaseActionParamsQueue, SetDatabaseActionParamsQueue,
        databaseResultAction, SetDatabaseResultAction, databaseShouldShowWaitScreen
    }) => {
    //context
    const appContext = useContext(AppContext);
    //controllers
    const iencryptor = new InfinityEncryptor('22499', 'MYDIH');
    // const waitscreen = new WaitScreenInterfaceController(appContext);

    //lifecycle
    useEffect(() => {
        //FetchSponsorsFromServer();
    }, []);

    //watch for database action commands queue process update
    useEffect(() => {
        if(
            databaseActionModeQueue.length > 0 &&
            databaseActionParamsQueue.length > 0 &&
            databaseActionModeQueue.length == databaseActionParamsQueue.length &&
            databaseResultAction == null
        ) {
            SetDatabaseResultAction(() => DatabaseResultAction);
        }
    }, [databaseActionModeQueue, databaseActionParamsQueue, databaseResultAction]);

    //test
    // useEffect(() => {
    //     console.log('DatabaseControllerTest:\n ' + JSON.stringify(databaseActionModeQueue) + '\n\n' + JSON.stringify(databaseActionParamsQueue));
    // }, [databaseActionModeQueue, databaseActionParamsQueue]);

    //exe function
    const DatabaseResultAction = async () => {
        //unqueue first databaseActionMode & databaseActionParams
        //unqueue databaseActionParams index = 0

        const formData = new FormData();
        formData.append('s3cr3t', iencryptor.Encrypt(appContext.staticAppConfig.secret));

        const _databaseActionParams = databaseActionParamsQueueRef.current.length > 0 ? databaseActionParamsQueueRef.current.shift() : [];

        _databaseActionParams.map((param: any) => {
            const encryption = (param.length == 3 ? param[2] : true); //default encryption to true if not set 
            if(encryption)
                formData.append(param[0], iencryptor.Encrypt(EscapeQuotes(param[1])));
            else
                formData.append(param[0], 'NOENCRYPT' + EscapeQuotes(param[1]));
        });

        if(databaseShouldShowWaitScreen) {
            // appContext.SetWaitScreenMessage('please wait');
            // appContext.SetWaitScreenShouldShow(true);
            // waitscreen.Queue(nonstate.screenWaitTaskID, 'please wait');
        }

        // ResetDatabaseRequest(); --deprecated, actionMode and actionParams should auto unqueue itself now

        //unqueue databaseActionMode
        const _databaseActionMode = databaseActionModeQueueRef.current.shift();

        //update state to complete the unqueueProcess
        SetDatabaseActionModeQueue([...databaseActionModeQueueRef.current]);
        SetDatabaseActionParamsQueue([...databaseActionParamsQueueRef.current]);

        console.log('checkDatabaseActionMode0: ' + _databaseActionMode);
        console.log('checkDatabaseActionMode1: ' + nonstate.dbScriptFileMap[_databaseActionMode as keyof typeof nonstate.dbScriptFileMap]);

        return await axios.post(appContext.staticAppConfig.dburl + nonstate.dbScriptFileMap[_databaseActionMode as keyof typeof nonstate.dbScriptFileMap], formData, { withCredentials: false })
            .then((res) => {
                // if(databaseShouldShowWaitScreen)
                    // appContext.SetWaitScreenShouldShow(false);
                    // waitscreen.Unqueue(nonstate.screenWaitTaskID);

                let resData = {} as any;
                try {
                    resData = JSON.parse(iencryptor.Decrypt(res.data)) as any;
                } catch {
                    resData = iencryptor.Decrypt(res.data) as any; //it's a string
                }

                requestAnimationFrame(() => {
                    SetDatabaseResultAction(null);
                });
                return [resData, _databaseActionMode];
            }).catch((err) => {
                if(databaseShouldShowWaitScreen)
                    // appContext.SetWaitScreenShouldShow(false);
                    // waitscreen.Unqueue(nonstate.screenWaitTaskID);

                requestAnimationFrame(() => {
                    SetDatabaseResultAction(null);
                });
                return ['databaseResultActionErr _false ' + err, _databaseActionMode];
            }); 
    }

    const EscapeQuotes = (subject: string) => {
        return subject.replace(/(['"\\])/g, '\\$1');
    }
    return (<Fragment />);
}
export default DatabaseRequestController;